import { IconButton } from '@chakra-ui/react';
import React from 'react';

import { RouteErrorBoundary } from '~/contexts/MonitoringProvider';
import { ComponentGridRenderer } from '~/core/routes/dev/ComponentGridRenderer';
import { PageTemplate } from '~/core/routes/dev/PageTemplate';
import { Icon } from '~/packages/common-frontend/components/icons';
import { COLOR_SCHEMES, SIZES } from '~/packages/common-frontend/theme';

// Constants
const COMPONENT_NAME = './chakra/IconButton';
const VARIANTS = [
  'primary',
  'primary-muted',
  'secondary',
  'secondary-muted',
  'v2-ghost',
] as const;

// Exports
export const Route = () => (
  <RouteErrorBoundary
    resetAfterCatch={false}
    fallback={({ message, showErrorToast }) => {
      showErrorToast(message);
      return <div>Uh oh</div>;
    }}
  >
    <PageTemplate title={COMPONENT_NAME}>
      <ComponentGridRenderer
        primaries={VARIANTS}
        primaryPropName="variant"
        secondaries={COLOR_SCHEMES}
        secondaryPropName="colorScheme"
        tertiaries={SIZES}
        tertiaryPropName="size"
      >
        {({ primary: variant, secondary: colorScheme, tertiary: size }) => {
          const Component = IconButton;

          const commonProps = {
            'aria-label': COMPONENT_NAME,
            colorScheme,
            variant,
            size,
            icon: variant.includes('link') ? (
              <span>Link</span>
            ) : (
              <Icon icon="message-lines" />
            ),
          };

          return (
            <>
              <Component {...commonProps} isLoading />
              <Component {...commonProps} isDisabled />
              <Component {...commonProps} />
              <Component {...commonProps} isActive />
            </>
          );
        }}
      </ComponentGridRenderer>
    </PageTemplate>
  </RouteErrorBoundary>
);
